var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-pagination',{staticClass:"mt-4",attrs:{"length":_vm.pagination.pages,"total-visible":10},on:{"input":function($event){return _vm.$emit('get-page',_vm.pagination.current)}},model:{value:(_vm.pagination.current),callback:function ($$v) {_vm.$set(_vm.pagination, "current", $$v)},expression:"pagination.current"}})
}
var staticRenderFns = []

export { render, staticRenderFns }